import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['video', 'playButton', 'thumbnail'];

  connect() {
    this.isPlaying = false;
    this.videoLoaded = false;

    // Set up the video source when the controller connects
    if (this.hasVideoTarget) {
      const videoElement = this.videoTarget;
      const videoSrc = videoElement.getAttribute('data-video-src');
      if (videoSrc) {
        videoElement.src = videoSrc;
      }
    }
  }

  play(event) {
    event.preventDefault();

    if (!this.hasVideoTarget) return;

    const video = this.videoTarget;

    if (this.isPlaying) {
      video.pause();
      this.isPlaying = false;

      if (this.hasPlayButtonTarget)
        this.playButtonTarget.classList.remove('hidden');
      if (this.hasThumbnailTarget) {
        this.thumbnailTarget.classList.remove('hidden');
        video.classList.add('hidden');
      }
    } else {
      if (!this.videoLoaded) {
        const videoSrc = video.getAttribute('data-video-src');
        if (videoSrc) {
          video.src = videoSrc;
          this.videoLoaded = true;
        }
      }

      if (this.hasThumbnailTarget) {
        this.thumbnailTarget.classList.add('hidden');
        video.classList.remove('hidden');
      }

      video.play().catch((error) => {
        console.error('Error playing video:', error);
        if (this.hasThumbnailTarget) {
          this.thumbnailTarget.classList.remove('hidden');
          video.classList.add('hidden');
        }
        if (this.hasPlayButtonTarget)
          this.playButtonTarget.classList.remove('hidden');
      });

      this.isPlaying = true;

      if (this.hasPlayButtonTarget)
        this.playButtonTarget.classList.add('hidden');
    }
  }

  download(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const url = link.getAttribute('href');
    const filename =
      link.dataset.filename || url.split('/').pop() || 'video.mp4';

    const originalContent = link.innerHTML;
    link.innerHTML = `<span class="loading loading-spinner loading-xs"></span> Downloading...`;

    fetch(url, {
      method: 'GET', // Removed all custom headers
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            'Fetch Network response was not ok:',
            response.status,
            response.statusText,
            response.type
          );
          return response.text().then((text) => {
            console.error('Fetch Error response body:', text);
            throw new Error(
              `Fetch Network response was not ok: ${response.status} ${response.statusText}`
            );
          });
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(blobUrl);
        document.body.removeChild(a);
        link.innerHTML = originalContent;
      })
      .catch((error) => {
        console.error('Download failed via fetch/blob method:', error);
        link.innerHTML = originalContent;

        console.log('Attempting fallback download for:', url, 'as', filename);
        const directLink = document.createElement('a');
        directLink.href = url;
        directLink.download = filename;
        directLink.style.display = 'none';
        document.body.appendChild(directLink);
        directLink.click();
        document.body.removeChild(directLink);
      });
  }
}
